import { render, staticRenderFns } from "./team_members.vue?vue&type=template&id=34970b00&scoped=true&"
import script from "./team_members.vue?vue&type=script&lang=js&"
export * from "./team_members.vue?vue&type=script&lang=js&"
import style0 from "./team_members.vue?vue&type=style&index=0&id=34970b00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34970b00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34970b00')) {
      api.createRecord('34970b00', component.options)
    } else {
      api.reload('34970b00', component.options)
    }
    module.hot.accept("./team_members.vue?vue&type=template&id=34970b00&scoped=true&", function () {
      api.rerender('34970b00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/prekickoff/view-team/team_members.vue"
export default component.exports